import { Region } from 'constants/shop';
import { CollectionHandles } from './types';

// spread into the registry, consumed by the cart discount pop-up scenarios
export const DISCOUNT_COLLECTION_HANDLES = {
  dogsSupplementsCheckoutSale: {
    [Region.DE]: 'fur-hunde-nahrungserganzer-sales-kasse',
    [Region.NL]: 'voor-honden-voedingssupplementen-sales-kassa',
  },
  dogsSnacksSpecialOffer: {
    [Region.DE]: 'fur-hunde-snacks-special-offer',
    [Region.NL]: 'voor-honden-snacks-special-offer',
  },
  catsSnacksSpecialOffer: {
    [Region.DE]: 'fur-katzen-snacks-special-offer',
    [Region.NL]: 'voor-katten-snacks-special-offer',
  },
} as const satisfies CollectionHandles;

export type DiscountCollectionKey = keyof typeof DISCOUNT_COLLECTION_HANDLES;
